// extracted by mini-css-extract-plugin
export default {"chatsTab":"ChatsTab_chatsTab__a6GUp","chatsAreaContainer":"ChatsTab_chatsAreaContainer__LBKce"};